import { useNavigate } from "react-router-dom";
import graphql from "babel-plugin-relay/macro";
import { useFragment } from "react-relay";

import { InspectionHeader$key } from "./__generated__/InspectionHeader.graphql";
import IconButton from "../../../components/Buttons/IconButton";

import { Header } from "../Styles";

export function InspectionHeader(props: {
  inspectionfield: InspectionHeader$key;
}) {
  const navigate = useNavigate();
  const { externalId, field } = useFragment(
    graphql`
      fragment InspectionHeader on InspectionfieldNode {
        externalId
        field {
          id
          previousId
        }
      }
    `,
    props.inspectionfield
  );
  const textDecoration = field ? "none" : "line-through";
  return (
    <Header>
      <IconButton
        icon="left"
        size="large"
        tooltip="Ga terug"
        onClick={() =>
          navigate(window.sessionStorage.getItem("main-page") || "/")
        }
      />
      <span
        style={{ marginLeft: "10px", textDecoration: `${textDecoration}` }}
      >{`BE ${externalId}`}</span>
    </Header>
  );
}
